<template>
  <div class="financeManage-system-page">
    <!-- <p class="hasBottomLine">借贷宝系统配置</p> -->
    <div class="configItem">
      <p class="item-title">1 .开关配置</p>
      <div class="item-action">
        <span class="desc-box">借贷宝开关 {{ openStatus }}</span>
        <el-switch
          style="display: block"
          v-model="configInfo.mortgageSwitch"
          active-color="#13ce66"
          inactive-color="#ff4949"
          active-text="开"
          inactive-text="关"
          disabled
          @click.native="handleOpenSwitch(openStatus)"
        >
        </el-switch>
      </div>
    </div>
    <div class="configItem">
      <p class="item-title">
        <span>2.订单配置</span> <el-button type="primary" @click="showDialog('countLimitDialog')">编辑</el-button>
      </p>
      <div class="item-action">
        <span class="desc-box"
          >1.单用户累计进行中的抵押借贷订单数量不能超过
          <label class="imitateInput"> {{ configInfo.userOrderLimit }}</label> 个</span
        >
      </div>
    </div>
    <div class="configItem">
      <p class="item-title">
        <span>3.风险率过低强平预警配置</span> <el-button type="primary" @click="showDialog('riskStepDialog')">编辑</el-button>
      </p>
      <div class="item-action">
        <span class="desc-box"
          >1.当订单风险率过低触发1次强平预警后，相比上一次订单风险率每降低
          <label class="imitateInput"> {{ configInfo.riskStep }}</label> %触发一次风险率过低强平预警</span
        >
      </div>
    </div>

    <div class="configItem">
      <p class="item-title">
        <span>4.运营相关配置</span> <el-button type="primary" @click="showDialog('operationDialog')">编辑</el-button>
      </p>
      <div class="item-action">
        <span class="desc-box"
          >1.单笔借贷金额 >=
          <label class="imitateInput"> {{ configInfo.largeAmount }}</label> USDT为大额借贷，其他为普通借贷</span
        >
      </div>
      <p class="item-remark">
        备注：当用户单笔借贷价值金额>=配置项时，发送大额借贷审核短信给审核人员，否则发送普通借贷审核短信通知
      </p>

      <div class="item-action">
        <span class="desc-box"
          >2.借贷宝申请平台审核人员联系方式： <label class="imitateInput"> {{ configInfo.auditTel }}</label>
        </span>
      </div>
      <p class="item-remark">
        备注：当平台产生借贷宝申请时，系统会短信通知该人员及时进行申请审核，大额借贷和普通借贷短信内容不同
      </p>

      <div class="item-action">
        <span class="desc-box"
          >3.借贷宝运营客服联系方式： <label class="imitateInput"> {{ configInfo.operateTel }}</label>
        </span>
      </div>
      <p class="item-remark">
        备注：当单笔大额借贷订单触发强平预警时，系统会同时短信通知该人员及时进行电话联系用户做好风险控制
      </p>
    </div>

    <!---dialog--->
    <el-dialog title="借贷宝开关" class="bk-ui5-dialog" :visible.sync="dialogArr.openSwitchDialog">
      <p class="descText" v-if="configInfo.mortgageSwitch == true">
        是否确认关闭借贷宝？关闭后用户无法提交新的借贷宝申请，关闭前已申请的不受影响！
      </p>
      <p v-else>是否确认开启借贷宝？</p>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogArr.openSwitchDialog = false">取 消</el-button>
        <el-button type="primary" @click="mortgageSwitchBtn()">确 定</el-button>
      </div>
    </el-dialog>

    <el-dialog title="订单配置" class="bk-ui5-dialog" :visible.sync="dialogArr.countLimitDialog">
      <p class="descText" v-if="openStatus == true">
        <span>借贷宝用户数量限制</span>
      </p>

      <div class="setInputBox">
        <el-input placeholder="单用户累计进行中的抵押借贷订单数量不能超过" v-model="limitNum">
          <template slot="append"
            >个</template
          >
        </el-input>
      </div>

      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogArr.countLimitDialog = false">取 消</el-button>
        <el-button type="primary" @click="countLimitBtn()">确 定</el-button>
      </div>
    </el-dialog>

    <el-dialog title="风险率过低强平预警配置" class="bk-ui5-dialog" :visible.sync="dialogArr.riskStepDialog">
      <p class="descText" v-if="openStatus == true">
        <span>订单风险率过低强平预警百分比配置</span>
        <span> 1<=X<=5，支持两位小数 </span>
      </p>

      <div class="setInputBox">
        <el-input placeholder="请输入配置数值" v-model="riskNum">
          <template slot="append"
            >%</template
          >
        </el-input>
      </div>

      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogArr.riskStepDialog = false">取 消</el-button>
        <el-button type="primary" @click="riskStepBtn()">确 定</el-button>
      </div>
    </el-dialog>

    <el-dialog title="运营相关配置" class="bk-ui5-dialog" :visible.sync="dialogArr.operationDialog">
      <div class="itemOne">
        <p class="descText">
          <span>大额借贷边界:</span>
          <span>1000<=X<=9999999，仅支持正整数 </span>
        </p>
        <div class="setInputBox">
          <el-input placeholder=" 请输入数值" v-model="operationForm.largeAmount">
            <template slot="append"
              >USDT</template
            >
          </el-input>
        </div>
      </div>

      <div class="itemOne">
        <p class="descText">
          <span>借贷宝申请平台审核人员联系方式：</span>
        </p>
        <div class="setInputBox">
          <el-input placeholder=" 请输入手机号码" v-model="operationForm.auditTel"> </el-input>
        </div>
      </div>
      <div class="itemOne">
        <p class="descText">
          <span>借贷宝运营客服联系方式：</span>
        </p>
        <div class="setInputBox">
          <el-input placeholder=" 请输入手机号码" v-model="operationForm.operateTel"> </el-input>
        </div>
      </div>

      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogArr.operationDialog = false">取 消</el-button>
        <el-button type="primary" @click="operationBtn()">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import "../store";
import api from "../api";
import { mapActions, mapGetters, mapState } from "vuex";
export default {
  name: "System",
  data() {
    return {
      shareTime: new Date(),
      openStatus: true,
      dialogArr: {
        openSwitchDialog: false,
        countLimitDialog: false,
        riskStepDialog: false,
        operationDialog: false
      },
      limitNum: "",
      riskNum: "",
      operationForm: {
        auditTel: "",
        largeAmount: "",
        operateTel: ""
      }
    };
  },
  computed: {
    ...mapState("FinanceManage", ["configInfo"])
  },
  methods: {
    ...mapActions("FinanceManage", ["getMortgageConfig"]),
    handleSearch() {},
    showDialog(n) {
      this.dialogArr[n] = true;
    },
    handleOpenSwitch(openStatus) {
      this.dialogArr.openSwitchDialog = true;
      return false;
    },
    clearForm() {
      this.dialogArr.openSwitchDialog = false;
      this.dialogArr.countLimitDialog = false;
      this.dialogArr.riskStepDialog = false;
      this.dialogArr.operationDialog = false;
      this.limitNum = "";
      this.riskNum = "";
      this.operationForm.auditTel = "";
      this.operationForm.largeAmount = "";
      this.operationForm.operateTel = "";
    },
    mortgageSwitchBtn() {
      let that = this;
      api
        .mortgageOpen({
          open: !that.configInfo.mortgageSwitch
        })
        .then(res => {
          if (!res.code) {
            that.$message.success(res.msg);
            that.clearForm();
            that.getMortgageConfig();
          } else {
            that.$message.error(res.msg);
          }
        });
    },
    countLimitBtn() {
      let that = this;
      api
        .mortgageCountLimit({
          limit: that.limitNum
        })
        .then(res => {
          if (!res.code) {
            that.clearForm();
            that.getMortgageConfig();
            that.$message.success(res.msg);
          } else {
            that.$message.error(res.msg);
          }
        });
    },
    riskStepBtn() {
      let that = this;
      api
        .mortgageRiskStep({
          step: that.riskNum
        })
        .then(res => {
          if (!res.code) {
            that.clearForm();
            that.getMortgageConfig();
            that.$message.success(res.msg);
          } else {
            that.$message.error(res.msg);
          }
        });
    },
    operationBtn() {
      let that = this;
      api.mortgageOperation(that.operationForm).then(res => {
        if (!res.code) {
          that.clearForm();
          that.getMortgageConfig();
          that.$message.success(res.msg);
        } else {
          that.$message.error(res.msg);
        }
      });
    }
  },
  created() {},
  mounted() {
    this.getMortgageConfig();
  }
};
</script>

<style lang="less">
.financeManage-system-page {
  width: 100%;
  height: 500px;
  .hasBottomLine {
    width: 100%;
  }

  .configItem {
    margin-bottom: 50px;
    padding-bottom: 30px;
    border-bottom: 1px solid #cccccc;
    .item-title {
      font-size: 18px;
      font-weight: bold;
      margin-bottom: 18px;
      display: flex;
      align-items: center;
      .el-button {
        margin-left: 50px;
      }
    }
    .item-action {
      display: flex;
      .desc-box {
        margin-right: 30px;
        .imitateInput {
          min-width: 60px;
          padding: 12px 20px;
          display: inline-block;
          text-align: center;
          border: 1px solid #cccccc;
          margin: 0 12px 0;
        }
      }

      .el-switch.is-disabled {
        opacity: 1;
      }
      .el-switch .is-disabled .el-switch__core,
      .el-switch.is-disabled .el-switch__label {
        cursor: pointer;
      }

      .el-switch.is-disabled .el-switch__core,
      .el-switch.is-disabled .el-switch__label {
        cursor: pointer;
      }
    }
    .item-remark {
      color: #ff8839;
      padding: 1px 0 22px 0;
    }
  }

  .bk-ui5-dialog {
    .el-dialog {
      width: 40%;
      .el-dialog__header {
        text-align: center;
      }
      .el-dialog__body {
        .itemOne {
          padding-bottom: 30px;
          .descText {
            display: flex;
            justify-content: flex-start;
            text-align: center;
          }
          .setInputBox {
          }
        }
      }

      .el-dialog__footer {
        display: flex;
        justify-content: center;
      }
    }
  }
}
</style>
